const API_BASE_URL =
  import.meta.env.VITE_API_URL || (import.meta.env.PROD ? '/api' : 'http://localhost:3001/api')

function getApiOrigin() {
  if (typeof window === 'undefined') {
    return ''
  }

  if (API_BASE_URL.startsWith('http://') || API_BASE_URL.startsWith('https://')) {
    return new URL(API_BASE_URL).origin
  }

  return window.location.origin
}

export function resolveMediaUrl(url?: string | null): string {
  const fallback = '/defaults/avatar.png'
  const value = url?.trim() || fallback

  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('data:')) {
    return value
  }

  if (value === fallback) {
    return fallback
  }

  if (value.startsWith('/api/') || value.startsWith('/uploads/')) {
    return `${getApiOrigin()}${value}`
  }

  return value
}
